import * as actionTypes from '../actionTypes';
import {clone, cloneDeep, remove, join, map} from 'lodash';

export const initialState = [];

function updateEmployee(currentEmployee, updatedEmployee) {
  if(currentEmployee.employeeId === updatedEmployee.employeeId) {
    return {...currentEmployee, ...updatedEmployee};
  }
  return currentEmployee;
}

export default function employeesReducer(state = initialState, {type, ...action}) {
  switch (type) {

    case actionTypes.CREATE_EMPLOYEE:
      return join(state, cloneDeep(action.employee));

    case actionTypes.REMOVE_EMPLOYEE:
      return remove(state, {employeeId: action.employeeId});

    case actionTypes.UPDATE_EMPLOYEE:
      return map(state, employee => updateEmployee(employee, action.employee));

    case actionTypes.STORE_EMPLOYEES:
      return cloneDeep(action.employees);

    case actionTypes.LOG_OUT:
      return clone(initialState);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./shared/redux/reducers/employees.js